"use strict";

/* A service / model */
_BannerFlowApp.factory("Brand", function ($resource, AuthInfo) {
    return $resource(
        "",
        {},
        {
            getLabels: {
                method: "GET",
                url: "{0}/api/brands/{1}/folders/common/labels".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                isArray: true
            },
            getActiveUsers: {
                method: "GET",
                url: "{0}/api/brands/{1}/folders/common/activeUsers".format(
                    BANNERFLOW_LEGACY_URL,
                    AuthInfo.LoggedInUser.currentBrand.id
                ),
                isArray: true
            }
        }
    );
});
